var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-linkedin",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M15,30A15,15,0,1,1,30,15,15.017,15.017,0,0,1,15,30Zm3.484-15.486c1.631,0,1.973,1.44,1.973,2.649V23.43H24.35V16.712a5.7,5.7,0,0,0-1.281-3.985,4.215,4.215,0,0,0-3.2-1.286,3.847,3.847,0,0,0-3.509,1.933V11.716H12.465c.05,1.081,0,11.607,0,11.714h3.893V16.888a2.572,2.572,0,0,1,.129-.95A2.128,2.128,0,0,1,18.484,14.513Zm-12.068-2.8V23.43H10.31V11.716ZM8.39,6.068a2.03,2.03,0,1,0-.052,4.048h.025A2.03,2.03,0,1,0,8.39,6.068Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon-linkedin.be3c8f427325914729bb9c866965cf9b.svg";
export { ForwardRef as ReactComponent };